import React from 'react';
import { TableIcon, UploadCloudIcon, EyeIcon, CheckCircleIcon, ClockIcon, FileTextIcon, ArrowRightIcon } from 'lucide-react';
export function RateTableModule({
  role
}: {
  role: string;
}) {
  const rateTables = [{
    id: 'RT-2026-03',
    product: 'Future Scholar Fund',
    version: 'v2.4',
    effectiveDate: '2026-04-01',
    uploadedBy: 'Adewale O.',
    status: 'Pending Approval'
  }, {
    id: 'RT-2026-02',
    product: 'Legacy Plan',
    version: 'v1.8',
    effectiveDate: '2026-01-01',
    uploadedBy: 'System',
    status: 'Active'
  }, {
    id: 'RT-2025-12',
    product: 'Freedom Fund',
    version: 'v3.1',
    effectiveDate: '2025-06-01',
    uploadedBy: 'Adewale O.',
    status: 'Active'
  }, {
    id: 'RT-2025-01',
    product: 'Future Scholar Fund',
    version: 'v2.3',
    effectiveDate: '2025-01-01',
    uploadedBy: 'System',
    status: 'Superseded'
  }];
  return <div className="space-y-6" data-id="element-620">
      <div className="flex justify-between items-center" data-id="element-621">
        <div data-id="element-622">
          <h2 className="text-2xl font-bold text-[#0D3B3B]" data-id="element-623">
            Rate Table Manager
          </h2>
          <p className="text-sm text-gray-500" data-id="element-624">
            Upload, validate, and approve actuarial rate tables.
          </p>
        </div>
        <button className="bg-[#0D3B3B] text-white px-4 py-2 rounded-xl font-bold text-sm flex items-center gap-2 hover:bg-[#092D2D] transition-colors" data-id="element-625">
          <UploadCloudIcon className="w-4 h-4" data-id="element-626" /> Upload CSV
        </button>
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden" data-id="element-627">
        <div className="overflow-x-auto" data-id="element-628">
          <table className="w-full text-left" data-id="element-629">
            <thead data-id="element-630">
              <tr className="bg-gray-50/50 text-xs uppercase tracking-wider text-gray-500 font-semibold" data-id="element-631">
                <th className="px-6 py-4" data-id="element-632">Rate Table ID</th>
                <th className="px-6 py-4" data-id="element-633">Product & Version</th>
                <th className="px-6 py-4" data-id="element-634">Effective Date</th>
                <th className="px-6 py-4" data-id="element-635">Uploaded By</th>
                <th className="px-6 py-4" data-id="element-636">Status</th>
                <th className="px-6 py-4" data-id="element-637">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-638">
              {rateTables.map(rt => <tr key={rt.id} className="hover:bg-gray-50" data-id="element-639">
                  <td className="px-6 py-4" data-id="element-640">
                    <div className="flex items-center gap-3" data-id="element-641">
                      <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center text-gray-500" data-id="element-642">
                        <TableIcon className="w-5 h-5" data-id="element-643" />
                      </div>
                      <span className="text-sm font-bold text-[#0D3B3B]" data-id="element-644">
                        {rt.id}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-645">
                    <div className="text-sm font-bold text-[#0D3B3B]" data-id="element-646">
                      {rt.product}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-647">
                      Version {rt.version}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700" data-id="element-648">
                    {rt.effectiveDate}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700" data-id="element-649">
                    {rt.uploadedBy}
                  </td>
                  <td className="px-6 py-4" data-id="element-650">
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold ${rt.status === 'Active' ? 'bg-emerald-100 text-emerald-700' : rt.status === 'Pending Approval' ? 'bg-amber-100 text-amber-700' : 'bg-gray-100 text-gray-600'}`} data-id="element-651">
                      {rt.status === 'Active' ? <CheckCircleIcon className="w-3.5 h-3.5" data-id="element-652" /> : rt.status === 'Pending Approval' ? <ClockIcon className="w-3.5 h-3.5" data-id="element-653" /> : <FileTextIcon className="w-3.5 h-3.5" data-id="element-654" />}
                      {rt.status}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-655">
                    <div className="flex items-center gap-3" data-id="element-656">
                      <button className="text-gray-400 hover:text-[#0D3B3B] transition-colors" data-id="element-657">
                        <EyeIcon className="w-5 h-5" data-id="element-658" />
                      </button>
                      {rt.status === 'Pending Approval' && role === 'Super Admin' && <button className="text-sm font-bold text-emerald-600 hover:text-emerald-700 bg-emerald-50 px-3 py-1.5 rounded-lg transition-colors" data-id="element-659">
                            Approve
                          </button>}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {/* Sample Rate Table Grid */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden mt-6" data-id="element-660">
        <div className="px-6 py-4 border-b border-gray-100 bg-gray-50 flex justify-between items-center" data-id="element-661">
          <div data-id="element-662">
            <h3 className="font-bold text-[#0D3B3B] text-sm" data-id="element-663">
              Preview: Future Scholar Fund (v2.4)
            </h3>
            <p className="text-xs text-gray-500" data-id="element-664">
              Rate per ₦1,000 Sum Assured (Monthly)
            </p>
          </div>
          <div className="flex items-center gap-2 text-xs font-bold" data-id="element-665">
            <span className="text-rose-500 bg-rose-50 px-2 py-1 rounded" data-id="element-666">
              Decreased
            </span>
            <span className="text-emerald-500 bg-emerald-50 px-2 py-1 rounded" data-id="element-667">
              Increased
            </span>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-668">
          <table className="w-full text-center text-sm" data-id="element-669">
            <thead data-id="element-670">
              <tr className="bg-gray-100 text-gray-600 font-bold" data-id="element-671">
                <th className="px-4 py-2 border-r border-white" data-id="element-672">Age / Term</th>
                <th className="px-4 py-2 border-r border-white" data-id="element-673">5 Years</th>
                <th className="px-4 py-2 border-r border-white" data-id="element-674">10 Years</th>
                <th className="px-4 py-2 border-r border-white" data-id="element-675">15 Years</th>
                <th className="px-4 py-2" data-id="element-676">20 Years</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-677">
              <tr data-id="element-678">
                <td className="px-4 py-3 font-bold bg-gray-50 border-r border-gray-100" data-id="element-679">
                  25
                </td>
                <td className="px-4 py-3 text-emerald-600 font-bold bg-emerald-50/30" data-id="element-680">
                  18.45 <ArrowRightIcon className="w-3 h-3 inline -rotate-45" data-id="element-681" />
                </td>
                <td className="px-4 py-3 text-gray-600" data-id="element-682">9.20</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-683">6.15</td>
                <td className="px-4 py-3 text-rose-600 font-bold bg-rose-50/30" data-id="element-684">
                  4.80 <ArrowRightIcon className="w-3 h-3 inline rotate-45" data-id="element-685" />
                </td>
              </tr>
              <tr data-id="element-686">
                <td className="px-4 py-3 font-bold bg-gray-50 border-r border-gray-100" data-id="element-687">
                  30
                </td>
                <td className="px-4 py-3 text-gray-600" data-id="element-688">18.90</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-689">9.55</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-690">6.45</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-691">5.10</td>
              </tr>
              <tr data-id="element-692">
                <td className="px-4 py-3 font-bold bg-gray-50 border-r border-gray-100" data-id="element-693">
                  35
                </td>
                <td className="px-4 py-3 text-gray-600" data-id="element-694">19.50</td>
                <td className="px-4 py-3 text-emerald-600 font-bold bg-emerald-50/30" data-id="element-695">
                  10.10 <ArrowRightIcon className="w-3 h-3 inline -rotate-45" data-id="element-696" />
                </td>
                <td className="px-4 py-3 text-gray-600" data-id="element-697">6.95</td>
                <td className="px-4 py-3 text-gray-600" data-id="element-698">5.65</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}